import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'asArray',
})
export class AsArrayPipe implements PipeTransform {
  transform<T>(value: [...T[]]): T[] {
    return value.map((v) => v);
  }
}
